import React, { useEffect, useState } from "react";
import { useEspelhoVendas } from "services/api/AppWeb_EspelhoVendas";
import * as Styles from "./styles";
import Header from "./Header";
import Footer from "./Footer";

interface Props {
  onClose: () => void;
  desconto: string;
  setDesconto: (desconto: string) => void;
  mutate?: any;
  refetch?: any;
  isLoading: boolean;
  isSuccess: boolean;
  reset3: () => void;
}

const DescontoModal: React.FC<Props> = (props) => {
  return (
    <Styles.Container>
      <Header onClose={() => props?.onClose()} />
      <Footer
        onClose={() => props?.onClose()}
        desconto={props?.desconto}
        setDesconto={props?.setDesconto}
        mutate={props?.mutate}
        refetch={props.refetch}
        isLoading={props?.isLoading}
        isSuccess={props?.isSuccess}
        reset3={props?.reset3}
      />
    </Styles.Container>
  );
};

export default DescontoModal;
